// Entry point for the build script in your package.json

import "./features/facebook";

// Lightbox2
import "jquery";
import "lightbox2";
